define.alias("shared/components/shared/ui/checkbox-switch", "calendar/components/shared/ui/checkbox-switch");